module.exports = __webpack_public_path__ + "img/40_69_002_830.ba489832.jpg";